<template>
  <div class="editor">
    <a-row type="flex" justify="space-around" align="middle">
      <a-col :span="23">
        <header>
          <h1>Google BigQuery JSON Schema Generator</h1>
          <a-button @click="generate" type="primary" :loading="isRunning" role="button" title="run">
            <i class="fa fa-fw fa-play"></i> RUN</a-button>
        </header>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-around" align="middle">
      <a-col :span="23" class="content-container">
        <section class="input-container">
          <textarea placeholder="JSON goes here..." v-model="input"></textarea>
        </section>
        <section class="output-container" style="position:relative">
          <a-alert v-if="hasNullOrUndefinedProps" message="You provided a JSON with null or undefined values. Used STRING type as a fallback." banner closable @close="onCloseHasNullOrUndefinedPropsAlert"/>
          <div style="text-align:right;padding:.2em; position:absolute; right:0;">
            <a-button @click="copy" type="primary" role="button" title="copy">
              <i class="fa fa-fw fa-copy"></i>COPY</a-button>
          </div>
          <div v-html="outputStr"></div>
        </section>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-around" align="middle">
      <a-col :span="23">
        <footer 
          style="display: flex;align-content: center; justify-content: space-between; margin:0"
        >
          <a href="https://www.buymeacoffee.com/richardaiko" target="_blank"><img src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" alt="Buy Me A Coffee" style="height: 40px !important;width: auto !important;" ></a>
          <div>
          <div>
            <div>
              <a 
                href="https://craftlabs.co" 
                style="color:#7569fb"
                target="_blank"
              >
                A Craft Labs Project
              </a>
            </div>
            <span>hi@craftlabs.co</span> &bull;
            <span>Made with <i class="fa fa-heart"></i> in <a target="_blank" href="https://www.google.ca/maps/place/Calgary,+AB/@51.013214,-114.3543392,10z/data=!3m1!4b1!4m5!3m4!1s0x537170039f843fd5:0x266d3bb1b652b63a!8m2!3d51.0486151!4d-114.0708459">Calgary, Alberta</a></span>
          </div>
          
        </div>
        </footer>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import { bigQuerySchemaGenerator, prettify } from '../utils/index';

  export default {
    name: 'Editor',
    data() {
      return {
        input: '',
        output: '',
        isRunning: false,
        hasNullOrUndefinedProps: false
      }
    },
    computed: {
      outputStr() {
        return this.output ? prettify(this.output) : "";
      }
    },
    methods: {
      generate() {
        try {
          this.isRunning = true;
          bigQuerySchemaGenerator(this.input, result => {
            this.output = result.fields;
            this.hasNullOrUndefinedProps = result.hasNullOrUndefinedProps;
          });
          this.isRunning = false;
        } catch (e) {
          this.isRunning = false;
        }
      },
      onCloseHasNullOrUndefinedPropsAlert() {
        this.hasNullOrUndefinedProps = false;
      },
      copy() {
        navigator.clipboard && navigator
          .clipboard
          .writeText(JSON.stringify(this.output, null, '\t'));
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


h1, h2, h3, h4, h5, h6 {
  font-family: 'Lato', sans-serif;
}

h1 {
  font-size: 18px;
  margin-bottom: 50px;
  color: #2B85E7;
  margin: 0;
}

header {
  padding: 1.7rem 0;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content-container {
  display: flex;
  flex-direction: row;
  box-shadow: 0 0 2px gainsboro;
  border-radius: 2px;
  height: 80vh;
  border: solid 1px #dcdcdc;
}

.input-container {
  flex: 1;
  border-right: 0;
  border-right: solid 1px #dcdcdc;
}

.input-container > section {
  padding: 25px 10px ;
}

.input-container > textarea {
  width: 100%;
  height: 100%;
  max-height: 90vh;
  border: 0;
  font-size: 13px;
  font-family: monospace;
  resize: none;
  padding: 10px;
  color: #617988;
}

.input-container > textarea:focus {
  box-shadow: none;
  outline: none;
}

.output-container {
  align-items: stretch;
  flex-direction: column;
  flex: 1;
  background-color: #fafafa;
  font-size: 13px;
  font-family: monospace;
  color: #333;
  white-space: pre;
  overflow: auto;
}

.output-container pre {outline: 1px solid #ccc; padding: 5px; margin: 5px; }

.output-container .string { color: green; }
.output-container .number { color: darkorange; }
.output-container .boolean { color: blue; }
.output-container .null { color: magenta; }
.output-container .key { color: red; }

footer {
  padding: 10px 0;
  text-align: right;
  color: #a9a9a9;
  font-size: 12px;
  margin-top: 1rem;
}

footer a {
  color: #a9a9a9;
}

</style>
